<template>
  <svg viewBox="0 -4 196 280" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M71.0368 18C71.7757 7.97144 83.565 0 98 0C112.435 0 124.224 7.97144 124.963 18H140V28H158C178.987 28 196 45.0132 196 66V202C196 222.987 178.987 240 158 240H77.3901C85.3253 235.644 92.1111 229.454 97.1767 222H158C169.046 222 178 213.046 178 202V66C178 54.9543 169.046 46 158 46H140V57H57V46H38C26.9543 46 18 54.9543 18 66V142.823C10.5464 147.889 4.35618 154.675 0 162.61V66C0 45.0132 17.0132 28 38 28H57V18H71.0368ZM104 12C104 15.3137 101.314 18 98 18C94.6863 18 92 15.3137 92 12C92 8.68629 94.6863 6 98 6C101.314 6 104 8.68629 104 12Z"
      fill="#1F2329"
    />
    <path
      d="M62.037 134.273C58.1567 133.439 54.1296 133 50 133C47.7684 133 45.5667 133.128 43.4019 133.378C42.5091 131.788 42 129.953 42 128C42 121.925 46.9249 117 53 117C59.0751 117 64 121.925 64 128C64 130.332 63.2745 132.494 62.037 134.273Z"
      fill="#1F2329"
    />
    <path
      d="M103.393 170C101.502 164.955 98.9169 160.25 95.7537 156H153V170H103.393Z"
      fill="#1F2329"
    />
    <path
      d="M64 94C64 100.075 59.0751 105 53 105C46.9249 105 42 100.075 42 94C42 87.9249 46.9249 83 53 83C59.0751 83 64 87.9249 64 94Z"
      fill="#1F2329"
    />
    <path d="M77 88H153V102H77V88Z" fill="#1F2329" />
    <path d="M77 122H153V136H77V122Z" fill="#1F2329" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M50 240C77.6142 240 100 217.614 100 190C100 162.386 77.6142 140 50 140C22.3858 140 0 162.386 0 190C0 217.614 22.3858 240 50 240ZM43 197V218H57V197H78V183H57V162H43V183H22V197H43Z"
      fill="#1F2329"
    />
  </svg>
</template>
